import React, { FunctionComponent } from "react";
import styled from "styled-components";

import { colours, uuid } from "utils";
import { CXL, CXXL } from "@/components/Typography";
import Device from "@/utils/device";
import StepForwardTitle from "../step-forward/StepForwardTitle";
import RxButton from "@/components/ui/inputs/RxButton";

const STAGES = [
  {
    title: (
      <>
        The Step <br />
        Forward <br />
        Stage
      </>
    ),
    copy: "Our main stage. Hosting a series of thought-provoking discussions and bringing together visionaries, personalities, and leaders to share insights and strategies for meaningful change. This is where the conversations defining our futures happen, with an incredible line-up of guests to be announced soon.",
  },
  {
    title: (
      <>
        The <br />
        Ambition <br />
        Stage
      </>
    ),
    copy: "The working world is in the midst of the biggest shake-up since the inception of the 9-5. It’s time we keep up or fall behind. The Ambition Stage welcomes speakers of all ages and stages of their career, from a range of industries to inspire your most successful year yet.",
  },
  {
    title: (
      <>
        The <br />
        Board <br />
        Room
      </>
    ),
    copy: "Home to practical, actionable, results-driven workshops that take you from what-if to how-to. Join us in The Board Room to learn the strategies required in today’s working world to take your career to the next level.",
  },
];

type StyleProps = {
  background?: string;
  textColour?: string;
};

type StagesContentProps = {
  handleClick: (e) => void;
};

const StagesContent: FunctionComponent<StagesContentProps> = (props) => {
  return (
    <S.Section data-cy="SF-content-themes">
      <S.CopyContainer>
        <StepForwardTitle colour={colours.shell}>
          <S.FontWeightWrap>Three </S.FontWeightWrap>
          <br />
          Incredible <br />
          Stages...
        </StepForwardTitle>
      </S.CopyContainer>
      <S.TableContainer>
        {STAGES.map((stage) => (
          <S.Row key={uuid()}>
            <StepForwardTitle>
              <S.FontWeightWrap>{stage.title}</S.FontWeightWrap>
            </StepForwardTitle>
            <CXL>{stage.copy}</CXL>
          </S.Row>
        ))}
      </S.TableContainer>
      <S.ButtonContainer>
        <RxButton
          background="#FFD869"
          textColour={colours.stepForwardBlue}
          onClick={props.handleClick}
        >
          <CXXL weight={400}>Get tickets now</CXXL>
        </RxButton>
      </S.ButtonContainer>
    </S.Section>
  );
};

const S = () => {};

S.Section = styled.section`
  position: relative;
  width: 100%;
  padding: 0 10%;
  background-image: url(/images/step-forward-2025/sunset-marble-background.png);
  background-repeat: no-repeat;
  background-size: cover;

  @supports not (-webkit-touch-callout: none) {
    background-attachment: fixed;
  }

  @media ${Device.tablet} {
    padding: 0% 10%;
  }
`;

S.CopyContainer = styled.div`
  padding: 50px 0;
  display: flex;
  justify-content: center;
  text-align: center;
`;

S.ButtonContainer = styled.div`
  margin: 50px auto;
  width: 40%;
  min-width: 280px;
  display: flex;
  justify-content: center;
`;

S.ItalicWrap = styled.span`
  font-style: italic;
`;

S.FontWeightWrap = styled.span`
  font-weight: 100;
`;

S.TableContainer = styled.div`
  background: ${colours.shell};
  padding: 10%;
  display: flex;
  flex-direction: column;
  gap: 40px;

  @media ${Device.mobile} {
  }

  @media ${Device.tablet} {
  }

  @media ${Device.desktop} {
    padding: 5% 10%;
    display: grid;
    grid-template-rows: repeat(3, 1fr);
    grid-gap: 50px;
  }
`;

S.Row = styled.div<StyleProps>`
  display: flex;
  flex-direction: column;
  gap: 10px;

  @media ${Device.tablet} {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    align-items: center;
  }
`;

S.PillarTitle = styled.h3<StyleProps>`
  color: ${(p) => p.textColour};
  text-align: center;
  font-size: 1.5rem;
  line-height: 1.5rem;

  @media ${Device.mobile} {
    font-size: 2.5rem;
    line-height: 2.5rem;
  }

  @media ${Device.desktop} {
    font-size: 3.7rem;
    line-height: 4rem;
  }
`;

S.RoxboroughFontWrap = styled.span`
  font-family:
    Roxborough CF,
    sans-serif;
  font-weight: 100;
  font-style: italic;
`;

export default StagesContent;
